import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'words'
})
export class WordsPipe implements PipeTransform {

  // numToWords :: (Number a, String a) => a -> String
  abbreviateNumber(value: number) {
    let val = value.toString();

    if (value < 1000) {
      return val;
    }

    if (value < 1000000) {
      return (value / 1000) + 'k';
    }

    return (value / 1000000) + ' million';
  }

  transform(value: number): string {
    if (!value) {
      return '';
    }

    return this.abbreviateNumber(value);
  }

}
